var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.4463C22.3022 16.4463 27.9997 21.4483 28 27C27.9999 27.5522 27.5522 28 27 28C26.4478 28 26.0001 27.5522 26 27C25.9997 22.9582 21.6522 18.4463 14 18.4463C6.34782 18.4463 2.00033 22.9582 2 27C1.99988 27.5522 1.55221 28 1 28C0.447788 28 0.000117494 27.5522 0 27C0.000315138 21.4483 5.69781 16.4463 14 16.4463ZM14.5 0C18.642 0 21.9998 3.31411 22 7.40234C22 11.4908 18.6421 14.8057 14.5 14.8057L14.1143 14.7959C10.1514 14.5977 7 11.3631 7 7.40234C7.00021 3.31411 10.358 0 14.5 0ZM14.5 2C11.4379 2 9.00021 4.44321 9 7.40234C9 10.3617 11.4377 12.8057 14.5 12.8057C17.5623 12.8057 20 10.3617 20 7.40234C19.9998 4.44321 17.5621 2 14.5 2Z",
    fill: "#661C69"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.e3b2ca6ebeef217e36fd2af437926268.svg";
export { ForwardRef as ReactComponent };